exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.radio-label[data-v-77dded5e] {\n  color: black;\n  font-weight: bold;\n}\n.radio-sub-label[data-v-77dded5e] {\n  color: #999;\n  font-size: .8em;\n  margin-left: 35px!important;\n}\n", ""]);

// exports
